module.exports = __webpack_public_path__ + "static/img/image1.3e226a55.png";